import { CFormSelect, CInputGroup } from '@coreui/react-pro'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DiagnosisCard from 'src/components/NewEncounter/DiagnosisCard'
import { initiateDiagnosisPlan, setDiagnosisCode } from 'src/redux/progressNote/progressNoteSlice'
import { setEncounterField } from '../../../redux/sidePanel/sidePanelSlice'
import { debouncer } from '../SidePanel/SideEncounterComponents/sharedPanelComponents/sharedAIfunctions'
import { saveEncounterField } from '../../../redux/sidePanel/sidePanelThunk'
import { getIsAi } from '../../../utils/sharedFeaturesFunctions'

const Problems = ({ option, statusOptions, onOptionChange }) => {
  return (
    <div className="problems">
      <div className="problem-item">
        <div className="dx-txt">
          <b>
            <p>{option?.code}</p>
          </b>
          <p>{option?.description}</p>
        </div>
        <div className="dx-input-holder">
          <div className="dx-input">
            <div className="select-holder">
              <CFormSelect
                aria-label={'Status'}
                label={'Status'}
                onChange={(e) => onOptionChange({ ...option, status: e?.currentTarget?.value })}
                value={option?.status}
              >
                {!option?.status && (
                  <option value={undefined} key={'placeholder'} disabled>
                    (tap to select)
                  </option>
                )}
                {statusOptions?.map((item, index) => (
                  <option value={item} key={index}>
                    {item}
                  </option>
                ))}
              </CFormSelect>
            </div>
            <div className="input-group">
              <label htmlFor="Management plan">Management plan</label>
              <CInputGroup className="flex-group">
                <textarea
                  className="form-control input-box"
                  placeholder={'(tap to enter med/management plan)'}
                  name="Management plan"
                  id="Management plan"
                  rows="3"
                  onChange={(e) => onOptionChange({ ...option, plan: e?.currentTarget?.value })}
                  value={option?.plan}
                ></textarea>
              </CInputGroup>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

// check if each code in 1 array matches another (to make sure arrays of same length do not have different codes)
function areOptionCodesEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false
  }

  return arr1.every((item, index) => item.code === arr2[index].code)
}

export default function DiagnosisPlan({ section, inputObjOnChange }) {
  const dispatch = useDispatch()
  const diagnosisCodesSelected = useSelector((state) => state?.progressNote?.diagnosisCodesSelected)

  const options =
    section?.options?.length > 0
      ? section?.options
      : !section?.disable
        ? []
        : diagnosisCodesSelected

  // since the `getInitialPayload` call can update the dx codes, this may have to stay here
  useEffect(() => {
    if (!areOptionCodesEqual(diagnosisCodesSelected, options)) {
      dispatch(initiateDiagnosisPlan(diagnosisCodesSelected))
    }
  }, [dispatch, diagnosisCodesSelected, options])

  const onOptionChange = (newOption, index) => {
    let newOptions = [...options]
    newOptions[index] = newOption

    inputObjOnChange(newOptions)
  }

  return (
    <div className="diagnosis-plan">
      <div className="diagnosis-holder">
        <DiagnosisCard
          setSelectedDiagnosis={(data) => {
            if (getIsAi()) {
              dispatch(
                setEncounterField({
                  field: 'diagnosisCodes',
                  value: data,
                }),
              )

              dispatch(setDiagnosisCode(data))
              debouncer(() => dispatch(saveEncounterField({})))
            } else {
              dispatch(setDiagnosisCode(data))
            }
          }}
          selectedDiagnosis={diagnosisCodesSelected}
          noIndicater={true}
          isProgressNote={true}
          title={'Select Diagnosis Code'}
          isBillSummary={true}
          showDescription={true}
          onOptionChange={onOptionChange}
          showPDPM={false}
        />
      </div>
      {/* Only show Status and Plan for diagnosisPlan sections*/}
      {section?.type === 'diagnosisPlan' && (
        <div className="proplem-holder">
          {options?.map((option, index) => {
            return (
              <Problems
                key={option?.code || '' + index}
                option={option}
                statusOptions={section?.statusOptions}
                onOptionChange={(newOption) => onOptionChange(newOption, index)}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}
